// services/TokenManager.js
import axios from 'axios';
import moment from 'moment';
import { Environment } from '@config';
import { AuthService, SnackbarService } from '@services';

let refreshPromise = null;

export const getAuthData = () => {
  try { return JSON.parse(localStorage.getItem('ls.authorizationData')) || null; }
  catch (e) { /* Error al parsear ls.authorizationData */ return null; }
};

export const setAuthData = (data) => {
  localStorage.setItem('ls.authorizationData', JSON.stringify({
    token: data.access_token,
    refreshToken: data.refresh_token,
    userName: data.userName,
    useRefreshTokens: true,
    expirationDate: moment().add(data.expires_in, 'seconds')
  }));
  // Notifica a otras pestañas
  try { bc?.postMessage({ type: 'auth:updated' }); } catch (e) { /* BroadcastChannel no soportado */ }
  window.dispatchEvent(new CustomEvent('auth:updated'));
};

export const isTokenExpired = (skewSeconds = 15) => {
  const a = getAuthData();
  if (!a?.expirationDate) return true;
  const now = new Date();
  const exp = new Date(a.expirationDate);
  return now >= new Date(exp.getTime() - skewSeconds * 1000);
};

const doRefreshWithRefreshToken = async () => {
  const env = Environment.getCurrent();
  const a = getAuthData();
  const language = JSON.parse(localStorage.getItem('ls.ty-Language'))?.language;

  const headers = { 'Content-Type': 'application/x-www-form-urlencoded', 'Accept-Language': language };
  const body = `grant_type=refresh_token&refresh_token=${encodeURIComponent(a.refreshToken)}&client_id=${env.clientId}`;

  const { data } = await axios.post(env.endpoints.auth, body, { headers });
  setAuthData(data);
  return data.access_token;
};

const doLoginWithCredentials = async () => {
  const env = Environment.getCurrent();
  const creds = JSON.parse(localStorage.getItem('ls.credentials') || localStorage.getItem('creds'));
  if (!creds?.userName || !creds?.password) throw new Error('NO_CREDENTIALS');

  const language = JSON.parse(localStorage.getItem('ls.ty-Language'))?.language;
  const headers = { 'Content-Type': 'application/x-www-form-urlencoded', 'Accept-Language': language };
  const body = `grant_type=password&username=${encodeURIComponent(creds.userName)}&password=${encodeURIComponent(creds.password)}&client_id=${env.clientId}&keep_session=true`;

  const { data } = await axios.post(env.endpoints.auth, body, { headers });
  setAuthData(data);
  return data.access_token;
};

export const refreshToken = async () => {
  if (refreshPromise) return refreshPromise; // single-flight
  refreshPromise = (async () => {
    try {
      // 1) intenta refresh_token
      return await doRefreshWithRefreshToken();
    } catch (e1) {
      // 2) si falla y hay credenciales (keepSession), intenta password
      try { return await doLoginWithCredentials(); }
      catch (e2) {
        // 3) sin credenciales: sesión expirada
        SnackbarService.error('Tu sesión ha expirado.');
        AuthService.clearStorage();
        AuthService.logout();
        throw e2;
      }
    } finally {
      refreshPromise = null;
    }
  })();
  return refreshPromise;
};

// Broadcast inter-pestañas
let bc = null;
try { bc = new BroadcastChannel('session'); } catch (e) { /* BroadcastChannel no soportado */ }
export const onAuthUpdated = (cb) => {
  const handler = () => cb();
  window.addEventListener('auth:updated', handler);
  bc?.addEventListener('message', (e) => { if (e.data?.type === 'auth:updated') cb(); });
  return () => window.removeEventListener('auth:updated', handler);
};
